import React from 'react';
import { Row, Col } from 'reactstrap';
import { Apify } from '../Apify';
import { current_site_id } from '../Site';

const DynamicBiatheElems = ({elems}) => {
	const { frontpage_left, frontpage_right } = elems;
	if(frontpage_left.length < 1 || elems.frontpage_right < 2) return null;
	return (
		<Row>
			<Col xs={12} lg={6} className='pr-md-1'>
				<div className='biathe_left pb-3 pb-md-0'>
					<a href={frontpage_left[0]['link']}>
						<img className='biathe_left' src={frontpage_left[0]['img@1x']} srcSet={frontpage_left[0]['img@2x'] + ' 2x'} alt="Left" />
					</a>
				</div>
			</Col>
			<Col xs={12} lg={6}>
				<div className='h-100 d-flex flex-column justify-content-between'>
					<div className='biathe_right pb-3 pb-md-0'>
						<a href={frontpage_right[0]['link']}>
							<img className='biathe_right' src={frontpage_right[0]['img@1x']} srcSet={frontpage_right[0]['img@2x'] + ' 2x'} alt="Right Top" />
						</a>
					</div>
					<div className='biathe_right'>
						<a href={frontpage_right[1]['link']}>
							<img className='biathe_right' src={frontpage_right[1]['img@1x']} srcSet={frontpage_right[1]['img@2x'] + ' 2x'} alt="Right Bottom" />
						</a>
					</div>
				</div>
			</Col>
		</Row>
	);
}

export default Apify("/z/webpage_elements?site="+current_site_id)
	.with_response_prop("elems")
.wrap((props) => {
	return <DynamicBiatheElems elems={props.elems} />;
});



// WEBPACK FOOTER //
// ./src/c/DynamicBiatheElems.js